export default "__VITE_ASSET__e465c19d__"